/**
 * The furthest milestone a fraction of the route has reached, or null.
 *
 * Milestones are compared by fraction rather than by array position, so a
 * route whose waypoints arrive out of order still resolves the right one.
 */
export function reachedRouteMilestone(milestones, progressFraction) {
    let reached = null;
    for (const [index, milestone] of milestones.entries()) {
        if (milestone.fraction > progressFraction)
            continue;
        if (reached && milestone.fraction <= reached.fraction)
            continue;
        reached = {
            index,
            fraction: milestone.fraction,
            title: milestone.title,
            description: milestone.description,
        };
    }
    return reached;
}
/** The next milestone still ahead of a fraction, or null at the finish. */
export function nextRouteMilestone(milestones, progressFraction) {
    let next = null;
    for (const [index, milestone] of milestones.entries()) {
        if (milestone.fraction <= progressFraction)
            continue;
        if (next && milestone.fraction >= next.fraction)
            continue;
        next = {
            index,
            fraction: milestone.fraction,
            title: milestone.title,
            description: milestone.description,
        };
    }
    return next;
}
/**
 * Reduce a route to at most `limit` points, keeping both ends.
 *
 * A community post carries its own copy of the route so the card stays an
 * immutable snapshot of what was true when it was shared. A full path is
 * hundreds of points; this keeps the shape at a few kilobytes.
 */
export function downsampleRoutePath(path, limit = 48) {
    if (limit < 2)
        return path.length ? [path[0]] : [];
    if (path.length <= limit)
        return [...path];
    const last = path.length - 1;
    const step = last / (limit - 1);
    const points = [];
    for (let index = 0; index < limit; index += 1) {
        const point = path[Math.round(index * step)];
        if (point)
            points.push(point);
    }
    return points;
}
//# sourceMappingURL=route-milestone.js.map